// extracted by mini-css-extract-plugin
export default {"ChatRoom":"ChatRoom-module-dbc4ae7653d5167a50d4","messages":"ChatRoom-module-e87bbea99c8a7db85f8e"};